export default "__VITE_ASSET__BMbLUPKP__"